// Vuetify 2 light theme – sourced from new-ui/global.json (light scheme)
// Material Design 3, blue-based palette
//
// success/warning: not in M3 export – kept functional until designer confirms
// accent: maps to M3 "tertiary" (#026B5D teal)
// anchor: uses primary color
export default {
  primary:   '#38608F',
  secondary: '#485D92',
  accent:    '#026B5D',
  error:     '#884B6B',
  info:      '#38608F',
  success:   '#026B5D',
  warning:   '#F07D0F',
  anchor:    '#38608F',
}
